import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard, ClipboardList, Package, History,
  DollarSign, PlusCircle, LogOut, UtensilsCrossed, Menu, X
} from "lucide-react";
import * as S from "./styles";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const menu = [
    { 
      title: "Operação", 
      items: [
        { to: "/NewOrder", label: "Novo Pedido", icon: PlusCircle },
        { to: "/OrderBoard", label: "Cozinha", icon: ClipboardList }
      ]
    },
    { 
      title: "Gestão", 
      items: [
        { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
        { to: "/ProductAdmin", label: "Cardápio", icon: UtensilsCrossed },
        { to: "/estoque", label: "Estoque", icon: Package }
      ]
    },
    { 
      title: "Relatórios", 
      items: [
        { to: "/historico", label: "Histórico", icon: History },
        { to: "/financeiro", label: "Financeiro", icon: DollarSign }
      ]
    }
  ];

  useEffect(() => { setIsOpen(false); }, [location]);

  return (
    <>
      <S.MobileMenuBtn onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </S.MobileMenuBtn>

      <S.Overlay isOpen={isOpen} onClick={() => setIsOpen(false)} />

      <S.SidebarContainer isOpen={isOpen}>
        <S.Logo>
          <div className="logo-wrapper">
            <img src="https://res.cloudinary.com/dfiahvacg/image/upload/if_w_gt_1000/c_scale,w_1000/if_end/ninjaburgue_y31nbs.jpg" alt="Logo" />
          </div>
          <div className="logo-text">
            Ninja<span>Burger</span>
          </div>
        </S.Logo>

        <S.NavList>
          {menu.map(group => (
            <div key={group.title} className="nav-group">
              <S.SectionTitle>{group.title}</S.SectionTitle>
              {group.items.map(item => (
                <S.NavItem key={item.to} as={NavLink} to={item.to} end={item.end}>
                  <div className="icon-area">
                    <item.icon size={20} />
                  </div>
                  <span>{item.label}</span>
                </S.NavItem>
              ))}
            </div>
          ))}
        </S.NavList>

        <S.LogoutArea>
          <S.LogoutButton onClick={() => alert("O sistema de LOGIN está em desenvolvimento.")}>
            <LogOut size={20} />
            <span>Sair do Sistema</span>
          </S.LogoutButton>
        </S.LogoutArea>
      </S.SidebarContainer>
    </>
  );
};

export default Sidebar;